import React from "react";
import { Box, Button, Inline } from "@origin-digital/ods-core";
import PermissionsControlledWrapper from "src/components/Permissions/PermissionsControlledWrapper";
import { PermissionEnum } from "src/components/Permissions/types";
import { useResponsiveBelowSm } from "src/hooks";

interface PermissionsActionButtonsProps {
  primaryOnClick: () => void;
  primarySpinner?: boolean;
  secondaryOnClick: () => void;
  secondaryDisabled?: boolean;
  secondarySpinner?: boolean;
}

const PermissionsActionButtons: React.FC<PermissionsActionButtonsProps> = ({
  primaryOnClick,
  primarySpinner,
  secondaryOnClick,
  secondaryDisabled,
  secondarySpinner,
}) => {
  const isBelowSm = useResponsiveBelowSm();
  return (
    <PermissionsControlledWrapper
      requiredPermission={PermissionEnum.CREATE_REQUEST}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        gap="medium"
      >
        <Button
          fullWidth={{
            xs: true,
            sm: false,
          }}
          onClick={primaryOnClick}
          spinner={primarySpinner}
        >
          <Inline>{isBelowSm ? "Lodge" : "Lodge request"}</Inline>
        </Button>
        <Button
          fullWidth={{
            xs: true,
            sm: false,
          }}
          variant="outlined"
          disabled={secondaryDisabled}
          spinner={secondarySpinner}
          onClick={secondaryOnClick}
        >
          Save draft
        </Button>
      </Box>
    </PermissionsControlledWrapper>
  );
};

export default PermissionsActionButtons;
